import "./SpoilerHeader.scss"

import { FC, ReactNode } from "react"
import cn from "classnames"

interface ISpoilerHeaderProps {
    title: ReactNode
    expanded: boolean
    onToggle(): void
}

const SpoilerHeader: FC<ISpoilerHeaderProps> = ({
    title,
    expanded,
    onToggle,
}) => {
    return (
        <button type="button" className={cn([
                "spoiler-header",
                { "spoiler-header--expanded": expanded },
            ])}
            data-testid="toggle-btn"
            onClick={onToggle}>
            <span className="spoiler-header__arrow"></span>
            {title}
        </button>
    )
}

export default SpoilerHeader
